import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChartsModule } from '@carbon/charts-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { PipesModule } from './pipes/pipes.module';
import { ProtocolDroidModule } from './services/protocol-droid/protocol-droid.module';
import { UiElementsModule } from './ui-elements/ui-elements.module';

import { FeedbackMessageComponent } from './components/feedback/feedback-message/feedback-message.component';
import { FeedbackSpinnerComponent } from './components/feedback/feedback-spinner/feedback-spinner.component';

@NgModule({
  imports: [
    BsDropdownModule,
    CommonModule,
    FormsModule,
    PerfectScrollbarModule,
    PipesModule,
    PopoverModule,
    UiElementsModule,
    ProtocolDroidModule,
    ChartsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [FeedbackMessageComponent, FeedbackSpinnerComponent],
  exports: [
    BsDropdownModule,
    ChartsModule,
    CommonModule,
    FormsModule,
    PerfectScrollbarModule,
    PipesModule,
    PopoverModule,
    UiElementsModule,
    ProtocolDroidModule,
    ReactiveFormsModule,
    RouterModule
  ]
})
export class SharedModule {}
